export default __webpack_public_path__ + "static/media/lifestyle-sample-3.c36f25f3.png";